export default "\nfloat fmap(in float v) {\n    return v;\n}\n";